import {
    BreakpointRangeProps,
    Container,
    SelectionCardGroup,
    SelectionCardGroupProps,
    Stack,
    Typography,
} from '@optimus-web/core';
import { getTemplateColumnsGridSize } from '../../utils/getTemplateColumnsGridSize';
import { CurrencySelectDialogTexts } from '../types';
import { SuggestedCurrencies } from './SuggestedCurrencies';

interface DefaultCurrencySectionProps extends BreakpointRangeProps {
    hasSuggestedCurrenciesCardGroupOptions: boolean;
    suggestedCurrenciesCardGroupOptions: SelectionCardGroupProps['options'];
    otherCurrenciesCardGroupOptions: SelectionCardGroupProps['options'];
    selectedCurrencyCode: string;
    texts: CurrencySelectDialogTexts;
    handleChange: (currencyCode: string | undefined) => void;
}

export const DefaultCurrencySection = ({
    hasSuggestedCurrenciesCardGroupOptions,
    suggestedCurrenciesCardGroupOptions,
    otherCurrenciesCardGroupOptions,
    selectedCurrencyCode,
    breakpointRange,
    texts,
    handleChange,
}: DefaultCurrencySectionProps) => {
    return (
        <Stack vertical>
            {hasSuggestedCurrenciesCardGroupOptions && (
                <>
                    <SuggestedCurrencies
                        suggestedCurrenciesTitleText={texts.suggestedCurrenciesTitle}
                        suggestedCurrenciesAriaLabelText={texts.suggestedCurrenciesAriaLabel}
                        suggestedCurrenciesCardGroupOptions={suggestedCurrenciesCardGroupOptions}
                        handleChange={handleChange}
                        breakpointRange={breakpointRange}
                    />

                    <Container padding={['300', '0']}>
                        <Typography textStyle="titleSmallStrong" as="div">
                            {texts.otherCurrenciesTitle}
                        </Typography>
                    </Container>
                </>
            )}

            <SelectionCardGroup
                inputValue={[selectedCurrencyCode]}
                onChange={(e_, newValue) => handleChange(newValue[1])}
                options={otherCurrenciesCardGroupOptions}
                showSelector={false}
                templateColumns={getTemplateColumnsGridSize(breakpointRange)}
                type="checkbox"
                aria-label={texts.otherCurrenciesAriaLabel}
            />
        </Stack>
    );
};
